import React from "react";
import environmentSettings from "@src/constants/environmentSettings";

export const ContactLink = () => {
  const { phone } = environmentSettings;
  
  return <a href={`tel:${phone}`}>{phone}</a>
};